import React, { FC } from "react";

import { GarderoboBlock } from "./Garderobo.styles";

const Garderobo: FC = () => {
  return <GarderoboBlock id="garderobo" />;
};

export default Garderobo;
